import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

function FAQItem({ question, answer }) {
    // useEffect(() => {
    //     // Mettre à jour le titre de la page
    //     document.title = "FAQ - Utilisateurs - Events";
        
    //   }, []);
    const [isOpen, setIsOpen] = useState(false);

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };
 
    return (
        <>
            <Helmet>
                <title>FAQ Utilisateurs - Questions Fréquentes | Events</title>
                <meta name="description" content="Tout ce que vous devez savoir avant d'acheter vos billets sur Events. Consultez nos réponses aux questions les plus courantes des utilisateurs." />
                <link rel="canonical" href={'https://eventsbilletterie.com/Events-usedFolder/FAQs-events?tab=user'} />
                <meta property="og:title" content="FAQ Utilisateurs - Questions Fréquentes | Events" />
                <meta property="og:description" content="Tout ce que vous devez savoir avant d'acheter vos billets sur Events. Consultez nos réponses aux questions les plus courantes des utilisateurs." />
                <meta name="twitter:title" content="FAQ Utilisateurs - Questions Fréquentes | Events" />
                <meta name="twitter:description" content="Tout ce que vous devez savoir avant d'acheter vos billets sur Events. Consultez nos réponses aux questions les plus courantes des utilisateurs." />
            </Helmet>
            <div
                className={`nc-FlightCardgroup p-4 sm:p-6 relative bg-white dark:bg-neutral-900 border border-neutral-100
                dark:border-neutral-800 rounded-2xl overflow-hidden hover:shadow-lg transition-shadow space-y-6 ${isOpen ? 'open' : ''}`}
            >
            <div className="sm:pr-20 relative">
                <a href="##" className="absolute inset-0"> </a>
                <span
                onClick={toggleAccordion}
                className="absolute right-0 bottom-0 sm:bottom-auto sm:top-1/2 sm:-translate-y-1/2 w-10 h-10 bg-neutral-50 dark:bg-neutral-800 rounded-full flex items-center justify-center cursor-pointer transform -rotate-180"
                >
                <i className={`text-xl las ${isOpen ? 'la-angle-up' : 'la-angle-down'}`} />
                </span>
                <div className="flex flex-col sm:flex-row sm:items-center space-y-6 sm:space-y-0">
                <h3
                    className="text-neutral-900 font-semibold text-lg md:text-lg md:!leading-[120%] lg:text-lg dark:text-neutral-100 max-w-4xl"
                >
                    {question}
                </h3>
                </div>
            </div>
            {isOpen && (
                <div className="p-4 md:p-4 border border-neutral-200 dark:border-neutral-700 rounded-2xl">
                    {answer}
                </div>
            )}
            </div>
        </>
    );
}

export default FAQItem;
